<div class="d-flex flex-column mb-2">
  <p class="title-input m-0">{{titleInput}}</p>
  <input class="bottom-border" type="text">
  <p class="description-input" *ngIf="descriptionInput">{{descriptionInput}}</p>
</div>
